const convertedVapidKey: Uint8Array = urlBase64ToUint8Array(
  "BNjFHy8RdYyebo3H8yhr_xszNwZicZK8r21xBF0RrE-B4OTBS8MwWcr2BqdRImlW2UoPyF6DEo8gwZo76wr5lqM"
);

function urlBase64ToUint8Array(base64String: string): Uint8Array {
  const padding: string = "=".repeat((4 - (base64String.length % 4)) % 4);

  const base64: string = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");

  const rawData: string = window.atob(base64);
  const outputArray: Uint8Array = new Uint8Array(rawData.length);

  for (let i: number = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

function sendSubscription(subscription: PushSubscription): Promise<Response> {
  return fetch(`${process.env.BACKEND_URL ?? ""}/notifications/subscribe`, {
    method: "POST",
    body: JSON.stringify(subscription),
    headers: {
      "Content-Type": "application/json"
    }
  });
}
const registerServiceWorker: () => void = () => {
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      void navigator.serviceWorker
        .register("/sw.js")
        .then((registration: ServiceWorkerRegistration) => {
          if (!registration.pushManager) {
            console.error("Push manager unavailable.");
            return;
          }

          void registration.pushManager.getSubscription().then(function (existedSubscription: PushSubscription | null) {
            if (existedSubscription === null) {
              registration.pushManager
                .subscribe({
                  applicationServerKey: convertedVapidKey,
                  userVisibleOnly: true
                })
                .then(function (newSubscription: PushSubscription) {
                  void sendSubscription(newSubscription);
                })
                .catch(e => {
                  if (Notification.permission !== "granted") {
                    // console.error("Permission was not granted.");
                  } else {
                    console.error("An error ocurred during the subscription process.", e);
                  }
                });
            } else {
              void sendSubscription(existedSubscription);
            }
          });
        })
        .catch(e => {
          console.error("An error ocurred during Service Worker registration.", e);
        });
    });
  }
};

export default registerServiceWorker;
